import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "expano-components";

import { checkProductCardView } from "utils/helpers";
import { removeDescriptionSectionImages } from "actions/product_group/description_sections";

import Item from "./components/Item";
import AssignImagesByFileName from "./components/AssignImagesByFileName";

const Images = ({
  channel,
  description_section_products,
  description_section_id,
  removeDescriptionSectionImages,
  ...rest
}) => {
  const [is_deleting, setDeleting] = useState(false);
  const [is_open_assign_images_modal, setOpenAssignImagesModal] =
    useState(false);

  const show_description_section_products = checkProductCardView({
    type: "description_section_product_image",
    channel_type: channel?.type,
  });

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await removeDescriptionSectionImages(description_section_id);
    } finally {
      setDeleting(false);
    }
  };
  const exist_some_image = description_section_products.some(
    ({ product_image }) => !!product_image?.id
  );

  return (
    <div className="images-box section-group__image">
      <div className="images-box__header">
        <p>Grafika</p>
        <div className="df gap-10 ai-c">
          {description_section_products?.length > 0 && (
            <Button
              type="add"
              text="Przypisz"
              onClick={() => setOpenAssignImagesModal(true)}
            />
          )}
          {exist_some_image && (
            <Button
              type="delete"
              text={is_deleting ? "Proszę czekać..." : "Usuń"}
              disabled={is_deleting}
              onClick={handleDelete}
            />
          )}
        </div>
      </div>
      <ul className="images-box__list">
        {show_description_section_products &&
          description_section_products?.length > 0 &&
          description_section_products
            .sort((a, b) =>
              a.product.sku.localeCompare(b.product.sku, undefined, {
                numeric: true,
                sensitivity: "base",
              })
            )
            .map((product) => (
              <Item
                key={product.id}
                data={product}
                image={product?.product_image?.image}
                {...rest}
              />
            ))}
      </ul>
      {is_open_assign_images_modal && (
        <AssignImagesByFileName
          description_section_id={description_section_id}
          product_id={description_section_products?.[0]?.product?.id}
          handleClose={() => setOpenAssignImagesModal(false)}
        />
      )}
    </div>
  );
};

export default connect(
  ({
    channel_product_group: {
      data: { channel },
    },
  }) => ({ channel }),
  (dispatch) => ({
    removeDescriptionSectionImages: (id) =>
      dispatch(removeDescriptionSectionImages(id)),
  })
)(withRouter(Images));
